export const REGULAR_CLASS_INSTRUCTOR_LIST = 'regular-class-instructor-list';
export const COURSE_INSTRUCTOR_LIST = 'course-instructor-list';



// WEBPACK FOOTER //
// ./app/constants/navigation.js